import { render, staticRenderFns } from "./EachTopicCardComponent.vue?vue&type=template&id=0d5c23d0&scoped=true&"
import script from "./EachTopicCardComponent.vue?vue&type=script&lang=js&"
export * from "./EachTopicCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./EachTopicCardComponent.vue?vue&type=style&index=0&id=0d5c23d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5c23d0",
  null
  
)

export default component.exports